/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ComfortBScaleAliases {
  CALM_AGITATION_FIELD = 'calm-agitation-field',
  CALM_AGITATION_FORM = 'calm-agitation-form',
  CALM_AGITATION_RG = 'calm-agitation-rg',
  CALM_AGITATION_TEXT = 'calm-agitation-text',
  COMFORT_B_SCALE_CONTENT_PANEL = 'comfort-b-scale-content-panel',
  COMFORT_B_SCALE_CONTEXTUAL_BAR = 'comfort-b-scale-contextual-bar',
  COMFORT_B_SCALE_LAYOUT = 'comfort-b-scale-layout',
  COMFORT_B_SCALE_PANEL = 'comfort-b-scale-panel',
  COMFORT_B_SCALE_REFERENCE = 'comfort-b-scale-reference',
  COMFORT_B_SCALE_REFERENCE_LINK = 'comfort-b-scale-reference-link',
  COMFORT_B_SCALE_REFERENCE_LINK_PANEL = 'comfort-b-scale-reference-link-panel',
  CRY_FIELD = 'cry-field',
  CRY_FORM = 'cry-form',
  CRY_RG = 'cry-rg',
  CRY_TEXT = 'cry-text',
  FACIAL_TENSION_FIELD = 'facial-tension-field',
  FACIAL_TENSION_FORM = 'facial-tension-form',
  FACIAL_TENSION_RG = 'facial-tension-rg',
  FACIAL_TENSION_TEXT = 'facial-tension-text',
  LEVEL_OF_CONSCIOUSNESS_FIELD = 'level-of-consciousness-field',
  LEVEL_OF_CONSCIOUSNESS_FORM = 'level-of-consciousness-form',
  LEVEL_OF_CONSCIOUSNESS_RG = 'level-of-consciousness-rg',
  LEVEL_OF_CONSCIOUSNESS_TEXT = 'level-of-consciousness-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  MUSCLE_TONE_FIELD = 'muscle-tone-field',
  MUSCLE_TONE_FORM = 'muscle-tone-form',
  MUSCLE_TONE_RG = 'muscle-tone-rg',
  MUSCLE_TONE_TEXT = 'muscle-tone-text',
  PHYSICAL_MOVEMENT_FIELD = 'physical-movement-field',
  PHYSICAL_MOVEMENT_FORM = 'physical-movement-form',
  PHYSICAL_MOVEMENT_RG = 'physical-movement-rg',
  PHYSICAL_MOVEMENT_TEXT = 'physical-movement-text',
  RESPIRATORY_RESPONSE_FIELD = 'respiratory-response-field',
  RESPIRATORY_RESPONSE_FORM = 'respiratory-response-form',
  RESPIRATORY_RESPONSE_RG = 'respiratory-response-rg',
  RESPIRATORY_RESPONSE_TEXT = 'respiratory-response-text',
}
export { ComfortBScaleAliases };
